// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tGe4Jj8kItkkTw_BC7ZL {
    flex: 1;
    padding: 32px !important;
    margin-bottom: 16px;
}

@media (width <= 767px) {
    .tGe4Jj8kItkkTw_BC7ZL {
        width: 100%;
        padding: 8px !important;
    }
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/AppointmentBooking/components/BookingFlow/BookingFlow.module.css"],"names":[],"mappings":"AAAA;IACI,OAAO;IACP,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI;QACI,WAAW;QACX,uBAAuB;IAC3B;AACJ","sourcesContent":[".wrapper {\n    flex: 1;\n    padding: 32px !important;\n    margin-bottom: 16px;\n}\n\n@media (width <= 767px) {\n    .wrapper {\n        width: 100%;\n        padding: 8px !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `tGe4Jj8kItkkTw_BC7ZL`
};
export default ___CSS_LOADER_EXPORT___;
